/**
 * Hook для загрузки списка городов (карт с is_menu_link=true) для быстрого перехода
 */

import { useQuery } from '@tanstack/react-query';

import { mapApi } from '../api/mapApi';
import type { MapSummary } from '../types';

export function useMapCities() {
  return useQuery<MapSummary[]>({
    queryKey: ['map', 'cities'],
    queryFn: () => mapApi.listCities(),
    staleTime: 5 * 60 * 1000, // 5 минут (города меняются редко)
  });
}

